import { COLLECT_OPPORTUNITIES } from 'config/operations'
import apolloClient from './apolloClient'

function isValidOpportunity(opportunity) {
  if (typeof opportunity === 'string') {
    const trimmedOpportunity = opportunity.trim()
    const drPattern = /^DR[0-9]{6,8}$/
    return drPattern.test(trimmedOpportunity)
  }
  return false
}

export function registerOpportunity(drNumber, projectID) {
  if (isValidOpportunity(drNumber)) {
    return collectOpprotunities([{ drNumber, projectID }])
  }
}

export function collectOpprotunities(opportunities) {
  return apolloClient.mutate({
    mutation: COLLECT_OPPORTUNITIES,
    variables: { opportunities },
  })
}
